import { Action } from '@ngrx/store';
import { ChecklistInbound, InProgressChecklist, SaveProtocolRequest } from '@models/*';

export class LoadChecklist implements Action {
    readonly type = ChecklistActionTypes.LOAD_CHECKLIST;

    constructor(
        public payload: {
            tourStopActionId: number;
        }
    ) {
    }
}

export class LoadChecklistSuccess implements Action {
    readonly type = ChecklistActionTypes.LOAD_CHECKLIST_SUCCESS;

    constructor(public payload: { tourStopActionId: number, checklist: ChecklistInbound }) {
    }
}

export class LoadChecklistFail implements Action {
    readonly type = ChecklistActionTypes.LOAD_CHECKLIST_FAIL;

    constructor(public payload: { tourStopActionId: number, error: any }) {
    }
}

export class LoadCrosscheck implements Action {
    readonly type = ChecklistActionTypes.LOAD_CROSSCHECK;

    constructor(
        public payload: {
            tourStopActionId: number;
        }
    ) {
    }
}

export class LoadCrosscheckSuccess implements Action {
    readonly type = ChecklistActionTypes.LOAD_CROSSCHECK_SUCCESS;

    constructor(public payload: { tourStopActionId: number, checklist: ChecklistInbound }) {
    }
}

export class LoadCrosscheckFail implements Action {
    readonly type = ChecklistActionTypes.LOAD_CROSSCHECK_FAIL;

    constructor(public payload: { tourStopActionId: number, error: any }) {
    }
}

export class SaveChecklistProgress implements Action {
    readonly type = ChecklistActionTypes.SAVE_CHECKLIST_PROGRESS;

    constructor(public payload: InProgressChecklist) {
    }
}

export class DeleteChecklistProgress implements Action {
    readonly type = ChecklistActionTypes.DELETE_CHECKLIST_PROGRESS;

    constructor(public payload: string) {
    }
}

export class SaveProtocolDraft implements Action {
    readonly type = ChecklistActionTypes.SAVE_PROTOCOL_DRAFT;

    constructor(public payload: SaveProtocolRequest) {
    }
}

export class SaveProtocolDraftSuccess implements Action {
    readonly type = ChecklistActionTypes.SAVE_PROTOCOL_DRAFT_SUCCESS;

    constructor(
        public payload: {
            tourStopActionId: number,
            transportInternalId: string,
            photosToUploadLength: number,
        }
    ) {
    }
}

export class SaveProtocolDraftFail implements Action {
    readonly type = ChecklistActionTypes.SAVE_PROTOCOL_DRAFT_FAIL;

    constructor(public payload: { tourStopActionId: number, error: any }) {
    }
}

export class SubmitProtocol implements Action {
    readonly type = ChecklistActionTypes.SUBMIT_PROTOCOL;

    constructor(public payload: SaveProtocolRequest) {
    }
}

export class SubmitProtocolSuccess implements Action {
    readonly type = ChecklistActionTypes.SUBMIT_PROTOCOL_SUCCESS;

    constructor(
        public payload: {
            tourStopActionId: number,
            transportInternalId: string,
            photosToUploadLength: number,
        }
    ) {
    }
}

export class SubmitProtocolFail implements Action {
    readonly type = ChecklistActionTypes.SUBMIT_PROTOCOL_FAIL;

    constructor(public payload: { tourStopActionId: number, error: any }) {
    }
}

export class HandleProtocolFetch implements Action {
    readonly type = ChecklistActionTypes.HANDLE_PROTOCOL_FETCH;
}

export class IncreasePhotoStep implements Action {
    readonly type = ChecklistActionTypes.INCREASE_PHOTO_STEP;

    constructor(public payload: { transportId: string, type: 'photos' | 'damagePhotos' }) {
    }
}

export class InitProtocolPhotosInTransit implements Action {
    readonly type = ChecklistActionTypes.INIT_PROTOCOL_PHOTOS_IN_TRANSIT;

    constructor(public payload: { [transportId: string]: { totalPhotos: number, currPhotos: number } }) {
    }
}

export class ProtocolPhotoTransitSuccess implements Action {
    readonly type = ChecklistActionTypes.PROTOCOL_PHOTO_TRANSIT_SUCCESS;

    constructor(public payload: string) {
    }
}

export class AddContactOnSite implements Action {
    readonly type = ChecklistActionTypes.ADD_CONTACT_ON_SITE;
    constructor(public payload: string) {

    }
}

export class ClearContactOnSite implements Action {
    readonly type = ChecklistActionTypes.CLEAR_CONTACT_ON_SITE;
}

export class AddChecklistForBulkSign implements Action {
    readonly type = ChecklistActionTypes.ADD_CHECKLIST_FOR_BULKSIGN;
    constructor(public payload: number) {}
}

export class RemoveChecklistForBulkSign implements Action {
    readonly type = ChecklistActionTypes.REMOVE_CHECKLIST_FOR_BULKSIGN;
    constructor(public payload: number) {}
}

export class  ClearCheclistForBulkSign implements Action {
    readonly type = ChecklistActionTypes.CLEAR_CHECKLISTS_FOR_BULKSIGN;
}

export class SubmitBulkSignProtocol implements Action {
    readonly type = ChecklistActionTypes.SUBMIT_BULK_SIGN_PROTOCOL;

    constructor(public payload: {
        tsaIds: number[];
        isCustomerOnSite: boolean;
        customerSignature?: string;
        driverSignature?: string;
        emailAvailable: boolean;
        email: string | null;
        contactOnSite: string;
    }) {}
}

export class SubmitBulkSignProtocolSuccess implements Action  {
    readonly type = ChecklistActionTypes.SUBMIT_BULK_SIGN_PROTOCOL_SUCCESS;

    constructor(public payload:  {
        protocolIds: number[]
    }) {}
}

export class SubmitBulkSignProtocolFail implements Action  {
    readonly type = ChecklistActionTypes.SUBMIT_BULK_SIGN_PROTOCOL_FAIL;

    constructor(public payload:  {
        protocolIds: number[]
    }) {}
}

export enum ChecklistActionTypes {
    LOAD_CHECKLIST = 'LOAD_CHECKLIST',
    LOAD_CHECKLIST_SUCCESS = 'LOAD_CHECKLIST_SUCCESS',
    LOAD_CHECKLIST_FAIL = 'LOAD_CHECKLIST_FAIL',
    LOAD_CROSSCHECK = 'LOAD_CROSSCHECK',
    LOAD_CROSSCHECK_SUCCESS = 'LOAD_CROSSCHECK_SUCCESS',
    LOAD_CROSSCHECK_FAIL = 'LOAD_CROSSCHECK_FAIL',
    SAVE_CHECKLIST_PROGRESS = 'SAVE_CHECKLIST_PROGRESS',
    DELETE_CHECKLIST_PROGRESS = 'DELETE_CHECKLIST_PROGRESS',
    SUBMIT_PROTOCOL = 'SUBMIT_PROTOCOL',
    SUBMIT_PROTOCOL_SUCCESS = 'SUBMIT_PROTOCOL_SUCCESS',
    SUBMIT_PROTOCOL_FAIL = 'SUBMIT_PROTOCOL_FAIL',
    SAVE_PROTOCOL_DRAFT = 'SAVE_PROTOCOL_DRAFT',
    SAVE_PROTOCOL_DRAFT_FAIL = 'SAVE_PROTOCOL_DRAFT_FAIL',
    SAVE_PROTOCOL_DRAFT_SUCCESS = 'SAVE_PROTOCOL_DRAFT_SUCCESS',
    HANDLE_PROTOCOL_FETCH = 'HANDLE_PROTOCOL_FETCH',
    INCREASE_PHOTO_STEP = 'INCREASE_PHOTO_STEP',
    INIT_PROTOCOL_PHOTOS_IN_TRANSIT = 'INIT_PROTOCOL_PHOTOS_IN_TRANSIT',
    PROTOCOL_PHOTO_TRANSIT_SUCCESS = 'PROTOCOL_PHOTO_TRANSIT_SUCCESS',
    ADD_CONTACT_ON_SITE = 'ADD_CONTACT_ON_SITE',
    CLEAR_CONTACT_ON_SITE = 'CLEAR_CONTACT_ON_SITE',
    ADD_CHECKLIST_FOR_BULKSIGN = 'ADD_CHECKLIST_FOR_BULKSIGN',
    REMOVE_CHECKLIST_FOR_BULKSIGN = 'REMOVE_CHECKLIST_FOR_BULKSIGN',
    CLEAR_CHECKLISTS_FOR_BULKSIGN = 'CLEAR_CHECKLISTS_FOR_BULKSIGN',
    SUBMIT_BULK_SIGN_PROTOCOL = "SUBMIT_BULK_SIGN_PROTOCOL",
    SUBMIT_BULK_SIGN_PROTOCOL_SUCCESS = "SUBMIT_BULK_SIGN_PROTOCOL_SUCCESS",
    SUBMIT_BULK_SIGN_PROTOCOL_FAIL = "SUBMIT_BULK_SIGN_PROTOCOL_FAIL",

}

export type ChecklistActions = LoadChecklist | LoadChecklistSuccess | LoadChecklistFail |
    LoadCrosscheck | LoadCrosscheckSuccess | LoadCrosscheckFail |
    SaveChecklistProgress | DeleteChecklistProgress |
    SaveProtocolDraft | SaveProtocolDraftSuccess | SaveProtocolDraftFail |
    SubmitProtocol | SubmitProtocolSuccess | SubmitProtocolFail | HandleProtocolFetch | IncreasePhotoStep |
    InitProtocolPhotosInTransit | ProtocolPhotoTransitSuccess |
    AddContactOnSite | ClearContactOnSite |
    AddChecklistForBulkSign | RemoveChecklistForBulkSign | ClearCheclistForBulkSign | SubmitBulkSignProtocol |
    SubmitBulkSignProtocolSuccess | SubmitBulkSignProtocolFail ;
